import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

import { services } from '@services/api'

export class servicesStore extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable errors = {}
    @observable generalOptions = []
    @action
    getList = async () => {
        this.loading = true
        services
            .servicesList()
            .then(res => {
                runInAction(() => {
                    this.list = res.data
                    this.errors = {}
                })
            })
            .catch(e => {
                runInAction(() => {
                    this.list = []
                    this.errors = { serverError: 'קיימת שגיאה בשרת' }
                })
            })
        this.loading = false
    }

    @action
    resetList = () => {
        this.list = []
    }

    @action
    getServices = async (
        id,
        isAssistant,
        this_,
        isFlyOption,
        isSoulCare,
        isSimpleSmile,
        isSimpleSmileOnly,
        isCriticalOnly,
        isCritical
    ) => {
        if (isFlyOption.length) return (this.generalOptions = isFlyOption)
        services
            .getGeneralOptions(id)
            .then(res => {
                runInAction(() => {
                    this.errors = {}
                    let filteredList = res.data
                    if (isAssistant) {
                        filteredList = filteredList.filter(({ id }) => [21, 39].includes(id))
                        this_.setState({ optionTitle: filteredList[0].option_name })
                        this_.setState({ optionId: filteredList[0].id })
                    }
                    if (!isSoulCare) filteredList = filteredList.filter(({ id }) => id !== 28)
                    if (!isSimpleSmile) filteredList = filteredList.filter(({ id }) => id !== 29)
                    if (isSimpleSmileOnly) {
                        filteredList = filteredList.filter(({ id }) => [29, 39].includes(id))
                        this_.setState({ optionTitle: filteredList[0].option_name })
                        this_.setState({ optionId: filteredList[0].id })
                    }
                    if (isCriticalOnly) {
                        filteredList = filteredList.filter(({ id }) =>
                            [30, 31, 32, 33, 34, 35, 36, 37, 38, 21, 39, 19].includes(id)
                        )
                    }
                    if (!isCritical) {
                        filteredList = filteredList.filter(
                            ({ id }) => ![30, 31, 32, 33, 34, 35, 36, 37, 38].includes(id)
                        )
                    }
                    //
                    this.generalOptions = filteredList
                })
            })
            .catch(e => {
                runInAction(() => {
                    this.generalOptions = []
                    this.errors = { serverError: 'קיימת שגיאה בשרת' }
                })
            })
    }
}

export default remotedev(new servicesStore())
